// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import grmrepEntity from './entities/grmrep.json';
import grmrepMenu from '../pages/grmrep/menu.json';
import grmrepFullForm from '../pages/grmrep/forms/full.json';
import grmrepContextForm from '../pages/grmrep/forms/context.json';
import grmrepMiniForm from '../pages/grmrep/forms/mini.json';
import grmrepLookupForm from '../pages/grmrep/forms/lookup.json';
import grmrepTableView from '../pages/grmrep/views/table.json';
import grmrepStagesView from '../pages/grmrep/views/stages.json';
import grmrepCardsView from '../pages/grmrep/views/cards.json';
import grmrepInlineView from '../pages/grmrep/views/inline.json';
import grmrepBacklogView from '../pages/grmrep/views/backlog.json';
import grmrepSplitView from '../pages/grmrep/views/split.json';
import grmrepCalendarView from '../pages/grmrep/views/calendar.json';
import grmrepDashboardView from '../pages/grmrep/views/dashboard.json';

/** Тип запису «Представник» зі сторінками пакета: меню, форми та подання з pages/grmrep/. */
export const grmrepDefinition: IRecordTypeDefinition = {
  ...grmrepEntity,
  views: assembleViewSet({
      table: grmrepTableView,
      stages: grmrepStagesView,
      cards: grmrepCardsView,
      inline: grmrepInlineView,
      backlog: grmrepBacklogView,
      split: grmrepSplitView,
      calendar: grmrepCalendarView,
      dashboard: grmrepDashboardView,
  }),
  form: grmrepFullForm,
  forms: { full: grmrepFullForm, context: grmrepContextForm, mini: grmrepMiniForm, lookup: grmrepLookupForm },
  menu: grmrepMenu,
} as IRecordTypeDefinition;
